<template>
  <div class="brd">
    <div v-for="(item, index) in items" v-bind:key="index">
      <div class="input-group mb-1" :class="[sizeVal]">
        <select
          class="input-group-text custom-select"
          v-model="items[index][0]"
          @change="selectChanged(index)"
        >
          <option v-for="item in days" v-bind:key="item.value" :value="item.value">{{$t(item.text)}}</option>
        </select>
        <VueClockPicker
          v-model="items[index][1]"
          active-color="#3a3e42"
          :input-class="sizeFullVal"
          placeholder="from"
          close-on-overlay
        />
        <template v-if="items[index].length == 4">
          <VueClockPicker
            v-model="items[index][2]"
            active-color="#3a3e42"
            :input-class="sizeFullVal"
            close-on-overlay
          />
          <VueClockPicker
            v-model="items[index][3]"
            active-color="#3a3e42"
            :input-class="sizeFullVal"
            close-on-overlay
          />
        </template>
        <div class="input-group-append">
          <span class="input-group-text pt" @click="deleteItem(index)" :title="deleteTootltip">x</span>
        </div>
      </div>
    </div>
    <b-button type="button" variant="brand" class="btn-sm mt-1" @click="addItem()">{{addLabel}}</b-button>
  </div>
</template>

<script>
import VueClockPicker from "../components/clock-picker";

export default {
  components: {
    VueClockPicker
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    addLabel: {
      type: String,
      required: true,
      default: () => "Add New Item"
    },
    deleteTootltip: {
      type: String,
      default: () => "Delete Item"
    },
    size: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      days: [
        { value: 8, text: "Every Day" },
        { value: 9, text: "Every xx minutes" },
        { value: 1, text: "Monday" },
        { value: 2, text: "Tuesday" },
        { value: 3, text: "Wednesday" },
        { value: 4, text: "Thursday" },
        { value: 5, text: "Friday" },
        { value: 6, text: "Saturday" },
        { value: 7, text: "Sunday" },
        { value: 11, text: "Monday from hh:mm to hh:mm every hh:mm" },
        { value: 12, text: "Tuesday from hh:mm to hh:mm every hh:mm" },
        { value: 13, text: "Wednesday from hh:mm to hh:mm every hh:mm" },
        { value: 14, text: "Thursday from hh:mm to hh:mm every hh:mm" },
        { value: 15, text: "Friday from hh:mm to hh:mm every hh:mm" },
        { value: 16, text: "Saturday from hh:mm to hh:mm every hh:mm" },
        { value: 17, text: "Sunday from hh:mm to hh:mm every hh:mm" }
      ]
    };
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    },
    sizeFullVal() {
      return this.size
        ? `form-control form-control-${this.size} br-none`
        : "form-control br-none";
    }
  },
  methods: {
    selectChanged(index) {
      if (this.items[index][0] >= 11 && this.items[index][0] <= 17) {
        if (this.items[index].length != 4) {
          this.items[index].push("00:00");
          this.items[index].push("00:00");
        }
      } else {
        if (this.items[index].length == 4) {
          this.items[index].pop();
          this.items[index].pop();
        }
      }
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem(index) {
      this.items.push([8, "00:00"]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
